import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams, Link } from 'react-router-dom';
import { Text } from '../legacy/style';
import ResetPasswordForm from '../legacy/components/forms/ResetPasswordForm';

import styled from 'styled-components';

const FullPageContainer = styled.div`
    background-color: ${({ theme }: { theme: any }) => theme.color.blue.light};
    min-height: 100vh;
    width: 100%;
    padding: 70px;
    box-sizing: border-box;
    /* Center everything both vertically and horizontally */
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
`;

const H1 = styled.h1`
    font-weight: bold;
    font-size: ${({ theme }: { theme: any }) => theme.font.size.big};
    color: ${({ theme }: { theme: any }) => theme.color.black.main};
    margin-bottom: 8px;
`;

const Container = styled.div`
    margin-top: 20px;
`;

export const ResetPasswordPage: FC = () => {
    const { t } = useTranslation();
    const [params] = useSearchParams();
    const token = params.get('token');

    if (!token) {
        return (
            <FullPageContainer>
                <H1>{t('reset-password.title')}</H1>
                <Text>{t('reset-password.invalid-token')}</Text>
                <Link to="/">{t('reset-password.back-to-login')}</Link>
            </FullPageContainer>
        );
    }

    return (
        <FullPageContainer>
            <H1>{t('reset-password.title')}</H1>
            <span>{t('reset-password.text')}</span>
            <Text>{t('reset-password.rule')}</Text>
            <Container>
                <ResetPasswordForm token={token} />
            </Container>
        </FullPageContainer>
    );
};
